/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Alpine from 'alpinejs';
import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import HeaderMenu from './navigation/header-menu';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import Modal from './modules/modal';
import ResponsiveImage from './modules/responsive-image';
import Video from './modules/video';
import MapVictoria from './modules/map-victoria.js';
import SliderEnola from './modules/slider-enola.js';
import Roster from './modules/roster.js';

const siteInitialization = () => {
	CookieByte.init();
	HeaderMenu.init();
	Accordion.initAll();
	ResponsiveImage.initAll();
	MediaViewer.init();
	Modal.initAll();
	ImageGallery.initAll();
	Form.init();
	Video.initAll();
	MapVictoria.init('GOOGLE_MAPS_JAVASCRIPT_API_KEY');
	SliderEnola.initAll();
	Roster.init();

	window.Alpine = Alpine;	
	Alpine.start();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
